import { COLORS } from '../lib/theme'

// 16×16 checkmark — used for "on" state
const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M3.5 8.5L6.5 11.5L12.5 4.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

// 16×16 X — used for "off" state
const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M4.5 4.5L11.5 11.5M11.5 4.5L4.5 11.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
)

export function Switch({
  on,
  onChange,
  disabled,
  'aria-label': ariaLabel,
}: {
  on: boolean
  onChange: (v: boolean) => void
  disabled?: boolean
  'aria-label'?: string
}) {
  return (
    <button
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!on)}
      style={{
        // Geometry: 52×32 px, border always 2 px to keep layout stable
        width: 52,
        height: 32,
        boxSizing: 'border-box',
        borderRadius: 999,
        border: on ? '2px solid transparent' : `2px solid ${COLORS.outline}`,
        background: on ? COLORS.primary : COLORS.surfaceContainerHighest,
        padding: 0,
        position: 'relative',
        flexShrink: 0,
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.38 : 1,
        transition: 'background 160ms ease, border-color 160ms ease',
      }}
    >
      {/* Handle — 24×24 px, slides left↔right */}
      <span
        aria-hidden="true"
        style={{
          position: 'absolute',
          // Padding-box height = 32 - 4 = 28 px; (28 - 24) / 2 = 2 px
          top: 2,
          // Padding-box width = 52 - 4 = 48 px
          // Off: 2 px gap from left. On: 48 - 2 - 24 = 22 px from left.
          left: on ? 22 : 2,
          width: 24,
          height: 24,
          borderRadius: 999,
          background: on ? COLORS.primaryFixed : COLORS.outline,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          // Icon colour: contrasts against each handle colour
          color: on ? COLORS.onPrimaryFixed : COLORS.surfaceContainerHighest,
          transition: 'left 160ms ease, background 160ms ease, color 160ms ease',
        }}
      >
        {on ? <CheckIcon /> : <CloseIcon />}
      </span>
    </button>
  )
}
